module.exports = __webpack_public_path__ + "img/i-sta-1.a02142fa.png";